import React from 'react';
import './icon.scss';
import { IconProps } from '../../types/icons';

const WhatsAppIcon: React.FC<IconProps> = ({
  fill,
  color,
  width = 24,
  height,
  onClick,
  className,
}) => {
  const classBase = 'custom-icon';
  const classes = `${classBase} ${classBase}-color-${color} ${className || ''}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height || width}
      className={classes}
      fill={fill || '#7E8A96'}
      onClick={onClick}
      data-testid="whats-app-icon"
      viewBox="0 0 29 29"
    >
      <path
        d="M24.2504 4.21149C21.6775 1.56284 18.1207 0.125 14.4883 0.125C6.76936 0.125 0.563957 6.40608 0.639633 14.0493C0.639633 16.4709 1.32071 18.8169 2.45585 20.9358L0.488281 28.125L7.82882
            26.2331C9.87207 27.3682 12.1423 27.898 14.4126 27.898C22.0558 27.898 28.2613 21.6169 28.2613 13.9736C28.2613 10.2655 26.8234 6.78446 24.2504 4.21149ZM14.4883 25.552C12.445 25.552 10.4018 25.0223
            8.66125 23.9628L8.2072 23.7358L3.81801 24.8709L4.95315 20.5574L4.65044 20.1034C1.32071 14.7304 2.9099 7.61689 8.35855 4.28716C13.8072 0.957432 20.845 2.54662 24.1748 7.99527C27.5045 13.4439 25.9153
            20.4818 20.4667 23.8115C18.7261 24.9466 16.6072 25.552 14.4883 25.552ZM21.1477 17.152L20.3153 16.7736C20.3153 16.7736 19.1045 16.2439 18.3477 15.8655C18.2721 15.8655 18.1964 15.7899 18.1207
            15.7899C17.8937 15.7899 17.7423 15.8655 17.591 15.9412C17.591 15.9412 17.5153 16.0169 16.4558 17.2277C16.3802 17.3791 16.2288 17.4547 16.0775 17.4547H16.0018C15.9261 17.4547 15.7748 17.3791
            15.6991 17.3034L15.3207 17.152C14.4883 16.7736 13.7315 16.3196 13.1261 15.7142C12.9748 15.5628 12.7477 15.4115 12.5964 15.2601C12.0667 14.7304 11.5369 14.125 11.1586 13.4439L11.0829 13.2926C11.0072
            13.2169 11.0072 13.1412 10.9315 12.9899C10.9315 12.8385 10.9315 12.6872 11.0072 12.6115C11.0072 12.6115 11.3099 12.2331 11.5369 12.0061C11.6883 11.8547 11.764 11.6277 11.9153 11.4764C12.0667 11.2493
            12.1423 10.9466 12.0667 10.7196C11.991 10.3412 11.0829 8.29797 10.8558 7.84392C10.7045 7.61689 10.5531 7.54122 10.3261 7.46554H10.0991C9.94774 7.46554 9.72071 7.46554 9.49369 7.46554C9.34234 7.46554
            9.19098 7.54122 9.03963 7.54122L8.96396 7.61689C8.81261 7.69257 8.66125 7.84392 8.5099 7.9196C8.35855 8.07095 8.28288 8.2223 8.13153 8.37365C7.6018 9.05473 7.29909 9.88716 7.29909 10.7196C7.29909 11.325
            7.45044 11.9304 7.67747 12.4601L7.75315 12.6872C8.43423 14.125 9.34234 15.4115 10.5531 16.5466L10.8558 16.8493C11.0829 17.0764 11.3099 17.2277 11.4613 17.4547C13.0504 18.8169 14.8667 19.8007 16.9099
            20.3304C17.1369 20.4061 17.4396 20.4061 17.6667 20.4818C17.8937 20.4818 18.1964 20.4818 18.4234 20.4818C18.8018 20.4818 19.2558 20.3304 19.5586 20.1791C19.7856 20.0277 19.9369 20.0277 20.0883
            19.8764L20.2396 19.725C20.391 19.5736 20.5423 19.498 20.6937 19.3466C20.845 19.1953 20.9964 19.0439 21.0721 18.8926C21.2234 18.5899 21.2991 18.2115 21.3748 17.8331C21.3748 17.6818
            21.3748 17.4547 21.3748 17.3034C21.3748 17.3034 21.2991 17.2277 21.1477 17.152Z"
        fill={fill || '#7E8A96'}
      />
    </svg>
  );
};

export default WhatsAppIcon;
